import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import Soccer from '../assets/images/soccer.png'
import Tennis from '../assets/images/tenis.png'
import cricket from '../assets/images/Cricket.png';
import { Link } from "react-router-dom";
import HorsRiding from '../assets/images/horsRiding.png'
import Dog from '../assets/images/dog.png'
import cricket12 from '../assets/images/cricket22.png'
import Mines from '../assets/images/mines.jpeg'
import Aviator from '../assets/images/aviator_n.jpeg'
import Aviator2 from '../assets/images/aviator2.jpeg'
import Plinko from '../assets/images/plinko.jpeg'

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';


// import required modules
import { FreeMode, Autoplay } from 'swiper/modules';



export default function Sports() {
  const swiperRef = useRef<any>(null); // Create a ref for the swiper instance
  const [activeButton, setActiveButton] = useState<string>('');

  const goNext = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slideNext();
      setActiveButton('next');
    }
  };

  const goPrev = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slidePrev();
      setActiveButton('prev');
    }
  };


  return (
    <>
      <div className="row">
        <div className="col-7 castom_m-y mt-0">
          <h1 className='mainTital d-flex justify-content-start align-items-center'>Sports 🧩</h1>
        </div>
        <div className="col-5 castom_m-y mt-0 text-end d-flex justify-content-end align-items-center">
          <h3 className='sumTital me-1'>
            All
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none" style={{ marginLeft: 1 }}>
              <path d="M7.84443 6.73748L4.36392 10.2179L5.35833 11.2123L9.83325 6.73748L5.35833 2.26256L4.36392 3.25697L7.84443 6.73748Z" fill="#CCCCCC" />
            </svg>
          </h3>
          <button className={`custom-prev ${activeButton === 'prev' ? 'sportActive' : ''} me-1`}
            onClick={goPrev}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
              <path d="M7.20779 6.68305L10.9369 10.4121L9.87146 11.4775L5.0769 6.68305L9.87146 1.88849L10.9369 2.95393L7.20779 6.68305Z" fill="#CCCCCC" />
            </svg>
          </button>
          <button className={`custom-next ${activeButton === 'next' ? 'sportActive' : ''}`}
            onClick={goNext}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
              <path d="M7.94602 6.68305L4.2169 10.4121L5.28234 11.4775L10.0769 6.68305L5.28235 1.88849L4.2169 2.95393L7.94602 6.68305Z" fill="#CCCCCC" />
            </svg>
          </button>
        </div>
        <div className="col-12">
          <Swiper
            ref={swiperRef}
            modules={[Autoplay, FreeMode]}
            autoplay={false}
            loop={false}
            // speed={500}
            slidesPerView={3}
            spaceBetween={12}
            breakpoints={{
              768: {
                slidesPerView: 3,
              },
              1024: {
                slidesPerView: 6,
              },
            }}
            freeMode={true}>
              <SwiperSlide>
              <div className='sportCard'>
                <Link to="/mines">
                  <img src={Mines} alt="cricket" className='img-fluid' />
                </Link>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='sportCard'>
                <Link to="/aviator">
                  <img src={Aviator} alt="cricket" className='img-fluid' />
                </Link>
              </div>
            </SwiperSlide>
            {/* <SwiperSlide>
              <div className='sportCard'>
                <Link to="/aviator">
                  <img src={Aviator2} alt="cricket" className='img-fluid' />
                </Link>
              </div>
            </SwiperSlide> */}
            <SwiperSlide>
              <div className='sportCard'>
                <Link to="/plinko">
                  <img src={Plinko} alt="cricket" className='img-fluid' />
                </Link>
              </div>
            </SwiperSlide>
            {/* <SwiperSlide>
              <div className='sportCard'>
                <Link to="/match-list">
                  <img src={cricket12} alt="cricket" className='img-fluid' />
                </Link>
              </div>
            </SwiperSlide> */}
            {/* <SwiperSlide>
              <div className='sportCard'>
                <img src={cricket} alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide> */}
            <SwiperSlide>
              <div className='sportCard'>
                <img src={Tennis} alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='sportCard'>
                <img src={Soccer} alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='sportCard'>
                <img src={HorsRiding} alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='sportCard'>
                <img src={Dog} alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='sportCard'>
                <Link to="/mines">
                  <img src={Mines} alt="cricket" className='img-fluid' />
                </Link>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='sportCard'>
                <img src={cricket12} alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='sportCard'>
                <img src={Tennis} alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='sportCard'>
                <img src={Soccer} alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='sportCard'>
                <img src={HorsRiding} alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='sportCard'>
                <img src={Dog} alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </>
  );
}
